export const autoSaveFormComponentModule = angular
  .module('Q.components.forms.auto-save-form', [])

  .directive('autoSaveForm', function () {
    return {
      restrict: 'A',
      require: 'form',
      link: function (scope, elem, attrs, ngForm) {
        scope.$on('$stateChangeStart', function (event) {
          if (event.defaultPrevented) return;
          if (ngForm.$valid) {
            if (/\(.*\)/.test(attrs.autoSaveForm)) {
              scope.$eval(attrs.autoSaveForm, { $event: event });
            } else {
              scope.$eval(attrs.ngSubmit, { $event: event });
            }
          }
        });
      },
    };
  });
